import { Select } from '@platform/design-system';
import type { TypedClient } from '@platform/openapi';
import { useOptions } from '../../catalog/useCatalogQueries.ts';
import { usePageContext } from '../../usePageContext.ts';
import { originChoicesOf } from './origin-choices.ts';

export type OriginFilterProps = {
  api: TypedClient;
  origin: string | null;
  onOriginChange: (origin: string | null) => void;
};

export const OriginFilter = ({ api, origin, onOriginChange }: OriginFilterProps) => {
  const { t, locale } = usePageContext();
  const options = useOptions(api).data?.items ?? [];
  const choices = originChoicesOf(
    options,
    {
      all: t('dashboard.filters.allOrigins'),
      local: t('origin.local'),
      allImported: t('dashboard.filters.allImported'),
      imported: (country) => t('origin.imported', { country }),
    },
    locale,
  );
  return (
    <Select
      label={t('dashboard.filters.origin')}
      value={origin ?? ''}
      options={choices}
      onChange={(event) => {
        onOriginChange(event.target.value === '' ? null : event.target.value);
      }}
    />
  );
};
